module.exports = __webpack_public_path__ + "static/media/19.d562eb78.svg";